/* unplugin-vue-components disabled */import { render } from "./tenant.vue?vue&type=template&id=4c4a0818&scoped=true"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=4c4a0818&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4a0818"],['__file',"src/pages/tenants/tenant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c4a0818"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c4a0818', __exports__)) {
    api.reload('4c4a0818', __exports__)
  }
  
  module.hot.accept("./tenant.vue?vue&type=template&id=4c4a0818&scoped=true", () => {
    api.rerender('4c4a0818', render)
  })

}


export default __exports__